import { useRef } from "react"
import { Navigate, Outlet } from "react-router-dom"

import { authClient } from "@/lib/api/auth"

/**
 * Inverse of `RequireAuth`: keeps signed-in users off `/login` (e.g. after
 * a refresh with a still-valid session cookie) by bouncing them to `/`
 * instead of showing the email form again.
 *
 * better-auth's session client refetches on every window/tab focus, and
 * while there's no session yet it reports `isPending: true` again for each
 * of those refetches (not just the first load) — see `getSessionAtom` in
 * better-auth's `session-atom.ts`. Gating on `isPending` unconditionally
 * would unmount `<Outlet />` (and `Login`'s in-progress OTP step state with
 * it) every time the tab regains focus mid-login. `hasLoadedOnce` limits the
 * loading gate to the very first resolution only.
 */
export function RequireGuest() {
  const { data, isPending } = authClient.useSession()
  const hasLoadedOnce = useRef(false)
  if (!isPending) hasLoadedOnce.current = true

  if (isPending && !hasLoadedOnce.current) return null

  if (data) return <Navigate replace to="/documents" />

  return <Outlet />
}
